import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'components/Select';

const BroadcastPicker = props => {
	const { broadcast, handlePickItem, event, auth0Token } = props;
	const { name, id } = event;
	const appName = 'Thālo Admin';

	const [broadcastEvents, setBroadcastEvents] = useState([]);
	const [selectedBroadcast, setSelectedBroadcast] = useState([]);

	useEffect(() => {
		const staging = window.origin.includes('/staging.') ? 'staging.' : '';
		const isProd = import.meta.env.MODE === 'production';
		const configURL = isProd ? `https://${staging}bs-backend.bpdev.club` : 'http://localhost:8000';

		axios
			.get(`${configURL}/api/folders/parent/${appName}/${name}/${id}/events`, {
				headers: { '0Authorization': `Bearer ${auth0Token}` },
			})
			.then(res => {
				const data = res.data;
				setBroadcastEvents(data[0].events);
			});
	}, [auth0Token, name, id]);

	useEffect(() => {
		if (broadcast && broadcast.includes('broadcasts')) {
			const broadcastKey = broadcast.split('/');
			const broadcastID = +broadcastKey[broadcastKey.length - 1];
			setSelectedBroadcast([broadcastID]);
		}
	}, [broadcast]);

	const handleSetBroadcastRoute = sessionId => {
		const broadcast = broadcastEvents.find(b => Number(b.id) === Number(sessionId));
		handlePickItem({
			route: `/broadcasts/${sessionId}`,
			name: broadcast ? broadcast.name : 'Broadcast',
		});
	};

	return (
		<div className="BroadcastPickerContainer">
			<Select
				data={broadcastEvents}
				value={selectedBroadcast || []}
				onChange={handleSetBroadcastRoute}
				placeholder="Select a broadcast"
			/>
		</div>
	);
};

export default BroadcastPicker;
